// Quelle: /opt/lilasprojekte/frontend/src/lib/storage.ts (Stand 2026-09-29)
// Geändert: PRAEFIX "hs." (SPEC 03 §3.1, R03-1).
/**
 * localStorage-Helfer. Alle Schlüssel tragen das Präfix `hs.` — dieselbe
 * Handschrift wie `zp.` im Zeitplaner, `lp.` in den Projekten, `fb.` im Fragenbüro, `spg.` in webgis
 * (SPEC §1). Das Präfix ist kein Schmuck: alle Hausanwendungen liegen unter
 * *.lilasp.de, und wer ohne Präfix "theme" schreibt, überschreibt es der
 * Nachbaranwendung — Ursprung ist zwar je Unterdomäne getrennt, aber die
 * Namen wandern beim Kopieren von Code mit.
 *
 * Beide Funktionen schlucken JEDEN Fehler und geben den Ersatzwert zurück:
 * im privaten Fenster, bei vollem Speicher und bei gesperrten Website-Daten
 * wirft schon der blosse Zugriff. Eine Oberfläche darf daran nicht sterben —
 * sie verliert dann eben ihre Merkfähigkeit, mehr nicht.
 */

const PRAEFIX = "hs.";

export function load<T>(key: string, fallback: T): T {
  try {
    const v = localStorage.getItem(PRAEFIX + key);
    return v === null ? fallback : (JSON.parse(v) as T);
  } catch {
    return fallback;
  }
}

export function save(key: string, val: unknown): void {
  try {
    localStorage.setItem(PRAEFIX + key, JSON.stringify(val));
  } catch {
    /* Kontingent voll oder privates Fenster — ignorieren */
  }
}

export function remove(key: string): void {
  try {
    localStorage.removeItem(PRAEFIX + key);
  } catch {
    /* s. o. */
  }
}
